import { Component, Input } from '@angular/core';
import { SiqLottieModule } from '@shared/lottie.module';
import { LottieHelper } from '@shared/utils/helpers/lottie-helper';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  standalone: true,
  imports: [SiqLottieModule]
})
export class LoadingComponent {
  @Input() width = '100px';
  @Input() height = '200px';
  loadingConfig = LottieHelper.createAnimationOptions('loader_particle', true);
}
